import { selector } from 'recoil';
import { OnlineSales } from 'gw-edge-client';
import { type EditCoverableAttributesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import type { OPCCoverableAttribute } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { opcInfoAtom } from '../atoms/opcInfoAtom';

export const getOPCCoverableAttributeSelector = selector<EditCoverableAttributesDTO>({
    key: 'getOPCCoverableAttribute',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const { productName, coverableId, attribute } = get(opcInfoAtom);
        return await OnlineSales.getOPCCoverableAttributeInfo(
            jobNumber,
            sessionId,
            coverableId,
            productName,
            attribute as OPCCoverableAttribute
        );
    }
});
